import React, { useState, useEffect } from "react"
import { Button, Row, Col, Input, InputGroup, InputGroupAddon, Tooltip } from "reactstrap"
import { useAuth0 } from "@auth0/auth0-react"
import Layout from "../../components/layout/layout"
import Content from "../../components/content/content"
import { useUserOrgs } from "../../hooks/use-user"
import Header from "../../components/header/header"
import { Loading } from "../../components/loading"
import { MdClose, MdPublic } from "react-icons/md"
import { AiFillLock } from "react-icons/ai"
import { FaSearch } from "react-icons/fa"
import { PropagateLoader } from "react-spinners"
import { fetch_get } from "../../utils/fetch"
import { checkPassword } from "../../utils/common"
import * as Sentry from "@sentry/gatsby"
import { css } from "glamor"
import Pagination from "@material-ui/lab/Pagination"
import { Link, navigate } from "gatsby"
import { useSearch } from "../../hooks/use-search"
import _ from "lodash"
import ProjectLinksView from "../../components/project-form/projectLinks/links-display"
import htmlToDraft from "html-to-draftjs"
import CommunityProjectOptions from "../../components/project-form/communityProject/container"

function ProjectButton(props) {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const toggle = () => setTooltipOpen(!tooltipOpen)
  if (!props.URL) {
    return <></>
  }
  let attr =
    props.Label === "Artifacts"
      ? {
        onClick: () => {
          const link =
            props.visibility === "private"
              ? `/projects/${props.parentOrganization}/private/${props.index}/#artifacts`
              : `/projects/${props.parentOrganization}/${props.index}/#artifacts`
          navigate(link)
        },
      }
      : { href: props.URL }

  return (
    <>
      <div className="mr-2" style={{ display: "inline-table",marginRight:0 }}>
        <Button
          {...attr}
          color="primary"
          className="mr-2 viewPublicProjects1"
        >
          <img
            className={`img-fluid d-inline-block`}
            {...css({ height: 25,marginRight:'5px' })}
            src={
              props.isActive
                ? `/${props.Label.toLocaleLowerCase()}.svg`
                : `/${props.Label.toLocaleLowerCase()}-grey.svg`
            }
            alt={props.Label}
            id={`project-${props.index}-${props.Label}`}
          />
          {props.Label}
        </Button>
      </div>
    </>
  )
}

function PublicProjectBlob(props) {
  let data = props.data
  const contentBlock = htmlToDraft(data.description)
  data.description = contentBlock.contentBlocks[0].text || ""

  const link =
    data.visibility === "private"
      ? `/projects/${data.parentOrganization}/private/${data.projectSlug}/`
      : `/projects/${data.parentOrganization}/${data.projectSlug}/`
  const classMap = {
    active: "activeBg",
    inactive: "inactiveBg",
    archived: "archivedBg",
  }
  return (
    <>
      <div
        className={`p-1 my-3 ${classMap[data.status]}`}
        style={
          data.status === "active"
            ? { backgroundColor: "#ebebeb" }
            : { backgroundColor: "#fff", border: "1px solid #ebebeb" }
        }
      >
        <div className="row p-3">
          <div className="col">
            <div className="float-left" style={{ display: "flex" }}>
              <Link to={link} state={{ search: window.location.search }}>
                <h2 {...css(styles.projectTitle)} className={`font-weight-bold`}>
                  {data.status === "active" ? (
                    <span>{data.name}</span>
                  ) : (
                    <span style={{ color: "#c2c2c2" }}>{`${data.name} (${_.upperFirst(
                      data.status
                    )})`}</span>
                  )}
                </h2>
              </Link>
              <div style={{ padding: 5 }}>
                {/* <VisibilityIcon {...data} index={props.index} /> */}
                <span
                  className="badge badge-light border border-dark "
                  style={{ textTransform: "capitalize" }}
                >
                  {data.visibility}
                </span>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="float-right">
              <CommunityProjectOptions project={data} />
            </div>
          </div>
          <div className="w-100"></div>
          <div className="col">
            <div className="float-left">
              <p
                style={{ marginBottom: "0.5rem", whiteSpace: "pre-wrap", wordBreak: "break-word" }}
              >
                {contentBlock.contentBlocks.length <= 1
                  ? data.description
                  : data.description + "... "}
                {contentBlock.contentBlocks.length <= 1 ? null : <Link to={link}>Read more</Link>}
              </p>
            </div>
          </div>
          <div className="col">&nbsp;</div>
          <div className="w-100"></div>
          <div className="col">
            <p className="mb-0">
              <ProjectButton
                URL={data.gitlabURL}
                Label="Git"
                index={data.projectSlug}
                isActive={data.status === "active"}
              />
              <ProjectButton
                URL={data.artifactoryURL}
                Label="Artifacts"
                index={data.projectSlug}
                parentOrganization={data.parentOrganization}
                visibility={data.visibility}
                isActive={data.status === "active"}
              />
              <ProjectButton
                URL={data.wikiURL}
                Label="Wiki"
                index={data.projectSlug}
                isActive={data.status === "active"}
              />
              {data.wikiURL.length && data.status === "active" && data.visibility === "public" ? (
                <ProjectButton
                  URL={process.env.CL_API_ENDPOINT + "/projects/" + data.projectId + "/wiki/rss"}
                  Label="RSS"
                  index={data.projectSlug}
                />
              ) : null}
            </p>
          </div>
          <div className="col">
            <div className="float-right">
              <ProjectLinksView project={data} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

function VisibilityIcon(props) {
  const { visibility, status, index } = props
  const classMap = {
    active: "text-primary",
    inactive: "text-warning",
    archived: "text-black-50",
  }
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const toggle = () => setTooltipOpen(!tooltipOpen)
  switch (visibility) {
    case "public":
      return (
        <>
          <MdPublic
            id={`ProjectVisibilityIcon-${index}`}
            // className={`mr-1 border-0 ${classMap[status]}`}
            style={{ fontSize: 24, cursor: "default" }}
          />
          <Tooltip
            placement="top"
            isOpen={tooltipOpen}
            autohide={false}
            container="projectsWrapper"
            target={`ProjectVisibilityIcon-${index}`}
            toggle={toggle}
          >
            {status === "active" ? `${visibility}` : `${visibility} (${_.upperFirst(status)})`}
          </Tooltip>
        </>
      )
    case "private":
      return (
        <>
          <AiFillLock
            id={`ProjectVisibilityIcon-${index}`}
            // className={`mr-1 border-0 ${classMap[status]}`}
            style={{ fontSize: 24, cursor: "default" }}
          />
          <Tooltip
            placement="top"
            isOpen={tooltipOpen}
            autohide={false}
            container="projectsWrapper"
            target={`ProjectVisibilityIcon-${index}`}
            toggle={toggle}
          >
            {status === "active" ? `${visibility}` : `${visibility} (${_.upperFirst(status)})`}
          </Tooltip>
        </>
      )
    default:
      return <MdPublic />
  }
}

const PublicProjects = () => {
  //const queryParams = new URLSearchParams(window.location.search)
  const queryParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
  const { isAuthenticated, user, getAccessTokenSilently } = useAuth0()
  const { loading } = useUserOrgs()
  const [apiPath] = useState(isAuthenticated ? "projects/union_public" : "projects/public")
  const [init, setInit] = useState(true)
  const [projectList, setProjectList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [noProjects, setNoProjects] = useState("There are no available projects.")
  const [pageCount, setPageCount] = useState(1)
  const [currentPage, setCurrentPage] = useState(parseInt(queryParams?.get("page") || 1))
  const [pageTotal, setPageTotal] = useState("")
  const [status, setStatus] = useState(queryParams?.get("status") || "")
  const [visibility, setVisibility] = useState(isAuthenticated ? queryParams?.get("visibility") || "all" : "all")
  const callback = v => {
    setCurrentPage(1)
    let searchString = ""
    const searchValue = v?.target?.value || ""
    if (searchValue !== "") {
      searchString += `&query=${searchValue}`
    }
    if (status !== "" && status !== "all") {
      searchString += `&status=${status}`
    }
    if (visibility !== "" && visibility !== "all") {
      searchString += `&visibility=${visibility}`
    }
    get_project_list(1, searchString)
  }

  const { search, setSearch, callback: handleSearchValue } = useSearch(callback, null, queryParams?.get('query') || '')

  let filterArr = [
    { name: "All", value: "all" },
    { name: "Active", value: "active" },
    { name: "Archived", value: "archived" },
  ]

  function onPageChange(event, page) {
    setCurrentPage(page)

    let searchString = ""
    if (search !== "") {
      searchString += `&query=${search}`
    }
    if (status !== "" && status !== "all") {
      searchString += `&status=${status}`
    }
    if (visibility !== "" && visibility !== "all") {
      searchString += `&visibility=${visibility}`
    }
    get_project_list(page, searchString)
  }

  const restartProjectList = () => {
    setCurrentPage(1)
  }

  const getProjects = (currentPage, searchString) => {
    window.history.pushState("", "", window.location.origin + window.location.pathname + `?page=${currentPage}${searchString}`)
    return isAuthenticated
      ? getAccessTokenSilently().then(accessToken =>
        fetch_get(`${apiPath}?page=${currentPage}${searchString}`, accessToken)
      )
      : fetch_get(`${apiPath}?page=${currentPage}${searchString}`, false)
  }

  const handleStatus = (item) => {
    setStatus(item.value)
    setCurrentPage(1)
  }

  function get_project_list(currentPage, searchString) {
    if (checkPassword(isAuthenticated, user)) return
    setIsLoading(true)
    setNoProjects("There are no available projects.")
    getProjects(currentPage, searchString)
      .then(response => {
        setInit(false)
        setProjectList(response["data"] || [])
        const totalRecords = response["pagination"]["totalRecords"] || 0
        const pageSize = response["pagination"]["pageSize"] || 10
        setPageCount(Math.ceil(totalRecords / pageSize))
        setPageTotal(totalRecords)
        setIsLoading(false)
      })
      .catch(error => {
        console.log(`Error while getting the list of projects: ${error}`)
        console.log(`${apiPath}?page=${currentPage}`)
        Sentry.captureException(error)
        setProjectList([])
        setNoProjects("An error occurred while getting the list of projects.")
        setIsLoading(false)
      })
  }
  useEffect(() => {

    let searchString = ""
    if (search !== "") {
      searchString += `&query=${search}`
    }
    if (status !== "" && status !== "all") {
      searchString += `&status=${status}`
    }
    if (visibility !== "" && visibility !== "all") {
      searchString += `&visibility=${visibility}`
    }
    if (init) {
      get_project_list(currentPage, searchString)
    } else {
      setCurrentPage(1)
      get_project_list(1, searchString)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, visibility, apiPath])

  const emptySearchValue = () => {
    let searchString = ""
    if (status !== "" && status !== "all") {
      searchString += `&status=${status}`
    }
    if (visibility !== "" && visibility !== "all") {
      searchString += `&visibility=${visibility}`
    }
    get_project_list(1, searchString)
  }

  if (loading) {
    return <Loading />
  }

  return (
    <Layout pageTitle="Projects">
      <Header contentPage={true} className="contentPage" backgroundImage="/dashborad_header.png">
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div>
            <h1 className="display-4 font-weight-bold">Projects</h1>
          </div>
          <div className="d-flex align-items-center" style={{ flex: 1, margin: "0px 15px" }}>
            <InputGroup>
              <Input
                value={search}
                placeholder="Search for a project..."
                onChange={event => handleSearchValue(event)}
                onKeyPress={event => {
                  if (event.key === "Enter") {
                    event.preventDefault()
                    document.getElementById("searchButton").click()
                  }
                }}
              />
              {search !== "" && (
                <InputGroupAddon className="clear_search" addonType="append">
                  <Button
                    onClick={() => {
                      setSearch("")
                      restartProjectList()
                      emptySearchValue()
                    }}
                  >
                    <MdClose />
                  </Button>
                </InputGroupAddon>
              )}
              <InputGroupAddon addonType="append">
                <Button id="searchButton">
                  <FaSearch />
                </Button>
              </InputGroupAddon>
            </InputGroup>
          </div>
          <div className="d-flex align-items-center">
            <span {...css(styles.pageTotal)}>{`Total ${pageTotal} items`}</span>
            <Pagination
              count={pageCount}
              page={currentPage}
              onChange={onPageChange}
              variant="outlined"
              shape="rounded"
            />
          </div>
        </div>
      </Header>
      <Content>
        <div style={{ marginLeft: "1rem", position: "relative" }}>
          {isAuthenticated && (
            <div style={{ width: 160, position: "absolute", right: 0 }}>
              <Input
                type="select"
                name="visibility"
                id="visibility1111"
                value={visibility}
                onChange={event => setVisibility(event.target.value)}
              >
                <option value="all">All Projects</option>
                <option value="public">Public Projects</option>
                <option value="private">Private Projects</option>
              </Input>
            </div>
          )}
          <div className="d-flex">
            {filterArr.map((item, index) => (
              <>
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
                <div
                  {...css(styles.statusCss)}
                  className={item.value === (status || 'all') ? "selectActiveInPublicProjects" : ""}
                  key={index}
                  onClick={() => handleStatus(item, index)}
                >
                  {item.name}
                </div>
              </>
            ))}
          </div>
        </div>
        <div {...css(styles.publicProjectContainer)} id="projectsWrapper">
          {isLoading ? (
            <Row>
              <Col
                className="d-flex justify-content-center align-items-center"
                xs={{ size: 12 }}
                sm={{ size: 4, offset: 4 }}
              >
                <PropagateLoader
                  className="align-self-center"
                  size={20}
                  color={"#9c3"}
                  loading={true}
                />
              </Col>
            </Row>
          ) : !isLoading && projectList.length === 0 ? (
            <Row>
              <Col xs={{ size: 12 }}>
                <p {...css(styles.noData)}>{noProjects}</p>
              </Col>
            </Row>
          ) : (
            <>
              <div>
                {projectList.map((p, index) => (
                  <div key={index}>
                    <PublicProjectBlob index={index} key={p.projectSlug} data={p} />
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
        <div style={{ float: "right", marginTop: "1rem" }} className="d-flex">
          <span {...css(styles.pageTotal)}>{`Total ${pageTotal} items`}</span>
          <Pagination
            count={pageCount}
            page={currentPage}
            onChange={onPageChange}
            variant="outlined"
            shape="rounded"
          />
        </div>
      </Content>
    </Layout>
  )
}

export default PublicProjects

const styles = {
  projectTitle: {
    color: "#9c3",
    // fontSize: "16px",
  },
  projectContainer: {
    backgroundColor: "#e6e6e6",
  },
  pageTotal: {
    color: "rgba(0, 0, 0, 0.87)",
    textAlign: "center",
    lineHeight: "30px",
    marginRight: "5px",
  },
  publicProjectContainer: {
    position: "relative",
    border: "0.75px solid #ebebeb",
    borderRadius: "12px",
    padding: "0px 1rem",
  },
  noData: {
    marginTop: "45px",
  },
  statusCss: {
    padding: "8px 15px",
    width: 100,
    textAlign: "center",
    color: "#9c3",
    cursor: "pointer",
  },
}
